import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';

const classNames = new BEMHelper('Toggle');

export default class Toggle extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        defaultOpen: PropTypes.bool,
        open: PropTypes.bool,
        onToggle: PropTypes.func,
        className: PropTypes.string,
        children: PropTypes.node
    };

    static defaultProps = {
        defaultOpen: false
    };

    state = {
        open: typeof this.props.open === 'undefined' ? this.props.defaultOpen : this.props.open
    };

    handleClick = () => {
        if (this.props.onToggle) {
            this.props.onToggle();
        } else {
            const { open } = this.state;
            this.setState({ open: !open });
        }
    };

    render() {
        const open = this.props.onToggle ? this.props.open : this.state.open;
        const { title, className, children } = this.props;

        return (
            <div className={classNames(null, null, className)}>
                <header className={classNames('header')}>
                    <button className={classNames('button', { open })} onClick={this.handleClick}>
                        {title}
                    </button>
                </header>
                <div className={classNames('content', { open })}>{children}</div>
            </div>
        );
    }
}
